<template>
  <div>
    <v-container
      fluid
      class="white elevation-3 margen d-flex"
    >
      <div class="d-flex justify-start">
        <v-btn small text class="mt-3 mx-3 grey lighten-2" to="/Pedidos">
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
      </div>
      <div class="mx-auto">
        <h1>Crear Pedido</h1>
      </div>
    </v-container>

    <v-card class="ma-3">
      <v-card-title>Datos:</v-card-title>
      <v-card-text>
        <v-text-field label="Descripcion" v-model="descripcion" filled dense hide-details="" />
      </v-card-text>

      <v-card-title>Proyectos Activos:</v-card-title>

      <v-card-text>
        <div class="allB">
            <!-- <div class="text-h6 mx-3 d-flex justify-center ma-1"> -->
                <v-data-table 
                :items="proyectos" 
                v-model="proyectoSeleccionado" 
                show-select 
                :headers="columnasProyectos"
                item-key="PROYECTO_ID"
                single-select
                @input="CargarArticulos(proyectoSeleccionado)"
                :footer-props="{
                    'items-per-page-options': [5, 10, 15, 20],
                  }"
                :items-per-page="5"
                >
                </v-data-table>
            <!-- </div> -->
        </div>
        
        <v-divider></v-divider>
        <!-- TABLA ARTICULOS -->
        <div>
          <div class="text-h6 mx-3 d-flex justify-center ma-1">
            <span
              class="mouse noselect"
              v-ripple
              @click="mostrarArticulos = !mostrarArticulos"
            >
              Artículos
              <v-icon dense light>
                {{ iconoFlecha }}
              </v-icon>
            </span>
          </div>

          <transition name="fade">
            <v-row v-if="mostrarArticulos" class="allB mt-2">
              <!-- PRIMERA TABLA -->
              <v-col cols="12" xs="12" sm="12" md="6" lg="6" class="">
                <v-card-title class="pt-0"> Artículos del proyecto

                  <v-divider dark class="ma-4" inline></v-divider>

                  <v-text-field
                    v-model="buscador"
                    append-icon="mdi-magnify"
                    label="Buscar"
                    single-line
                    hide-details
                  />
                </v-card-title>

                <v-data-table
                  class="elevation-1 grey lighten-2"
                  :headers="columnasArticulos"
                  :items="articulos"
                  :search="buscador"
                  :loading="cargando"
                  :footer-props="{
                    'items-per-page-options': [5, 10, 15, 20],
                  }"
                  :items-per-page="5"
                >
                  <template v-slot:[`item.actionEditar`]="{ item }">
                    <v-btn
                      @click="AgregarProducto(item)"
                      small
                      light
                      class="amber lighten-2"
                      style=""
                    >
                      Agregar
                    </v-btn>
                  </template>
                </v-data-table>
              </v-col>
          <!-- TERMINA LA PRIMERA TABLA -->
          <v-divider vertical style="border-color: rgba(0, 0, 0, 0.42)"></v-divider>
          <!-- SEGUNDA TABLA -->
              <v-col cols="12" xs="12" sm="12" md="6" lg="6" class="">
                <v-card-title class="pt-0">
                  <span>Articulos Agregados </span>

                  <v-divider dark class="ma-4" inline></v-divider>

                  <!-- <v-text-field
                    v-model="buscador2"
                    append-icon="mdi-magnify"
                    label="Buscar"
                    single-line
                    hide-details
                  /> -->

                  <v-divider dark class="ma-4" inline></v-divider>

                  <!-- <div class="d-flex"> -->
                      <v-autocomplete label="Almacen" v-model="almacenSeleccionado" :items="almacenes" item-text="NOMBRE" item-value="NOMBRE" hide-details="" return-object/>
                      <!-- <v-text-field
                        v-model="buscador3"
                        append-icon="mdi-magnify"
                        label="Buscar"
                        single-line
                        hide-details
                      /> -->
                  <!-- </div> -->
                </v-card-title>

                <v-data-table
                  class="elevation-1 grey lighten-2"
                  :headers="columnasAgregados"
                  :items="articulosAgregados"
                  :search="buscador2"
                >
                  <template v-slot:[`item.AccionCantidad`]="{ item }">
                    <v-text-field v-model="item.CANTIDAD"
                       
                      type="number" 
                      min="1"
                      max/>
                  </template>

                  <template v-slot:[`item.AccionNotas`]="{ item }">
                    <v-textarea
                      v-model="item.PRODUCTO"
                    />
                  </template>

                  <template v-slot:[`item.AccionQuitar`]="{ item }">
                    <v-btn @click="QuitarProducto(item)"
                    small text dark class="red darken-1">
                      Quitar
                    </v-btn>
                  </template>
                </v-data-table>
              </v-col>
              <!-- TERMINA LA SEGUNDA TABLA -->
            </v-row>
          </transition>

         
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <v-divider></v-divider>
      <!-- BOTONES -->
      <v-card-actions class="d-flex justify-space-around">
        <v-btn class="grey darken-1" dark @click="salir">Cancelar</v-btn>
        <v-btn class="primary" dark @click="crearPedido">Crear Pedido</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      //DATOS PARA MANDAR A BACKEND
      fechaSeleccionada: null,
      descripcion: "",
      proyID: "",
      //articulosAgregados: [],

      //DATOS PARA MOSTRAR/MODIFICAR
      modalFecha: false,
      minFecha: "",

      // TABLA/s ARTICULOS
      productos: [],
      articulos: [],
      almacenes: [],
      almacenSeleccionado:"",
      articulosAgregados: [],
      buscador: "",
      buscador2: "",
      cargando: false,
      mostrarArticulos: true,
      proyectoSeleccionado: [],
      proyectos: [],
      columnasProyectos:[
          {text: "Folio", value: "FOLIO"},
          {text: "Cliente", value: "NOMBRE"},
          {text: "Fecha Entrega", value: "FECHA_ENTREGA"},
          {text: "Usuario", value: "NOMBRE_USUARIO"},
      ],
      columnasArticulos: [
        { text: "Clave",    value: "CLAVE_MSP", width:'15%'},
        { text: "Almacen",   valie: "ALMACEN"},
        { text: "Articulo", value: "NOMBRE", filterable:false },
        { text: "Cantidad", value: "CANTIDAD"},
        //{ text: "Costo", value: "COSTO"},
        { text: "Agregar", sortable: false, value: "actionEditar", align: "right",},
      ],
      columnasAgregados: [
        { text: "Clave",    value: "CLAVE_MSP", width:'15%'},
        { text: "Cantidad", sortable: false, value: "AccionCantidad"},
        { text: "Articulo", value: "NOMBRE" },
        { text: "Accion", sortable: false, value: "AccionQuitar", align: "right",},
      ],
      // ----------------------------------------------------------------------
    };
  },

  // -----------------------------------------------------------------------------
  computed: {
    ...mapGetters(["getFechaActual", "getURLAPI","getUsuario"]),

    iconoFlecha: function () {
      return this.mostrarArticulos
        ? "mdi-arrow-up-drop-circle"
        : "mdi-arrow-down-drop-circle";
    },
  },

  // -----------------------------------------------------------------------------
  methods: {
    async getAlmacenes(){
      this.almacenes = (await axios.get(`${this.getURLAPI}/Show/allStorage`)).data;
      // console.log(this.almacenes);
    },
    // -----------------------------------------------------------------------------
    async GetProyectos()
    {
        this.proyectos = (await axios.get(`${this.getURLAPI}/Show/allProyect`)).data
    },
    CargarArticulos( proyectoSel )
    {
      this.articulosAgregados = [];
      this.proyID = 0;
      if (proyectoSel && proyectoSel.length > 0){
        this.proyID = proyectoSel[0].PROYECTO_ID;
        console.log( proyectoSel[0].PROYECTO_ID );
      } 
      
      let datosForm = new FormData();
      datosForm.append("PROYECTO_ID", this.proyID);
      axios.post(`${this.getURLAPI}/Pedidos/articulosProyecto`,datosForm)
      .then(({data}) =>{
        this.articulos = data;
      })
      //console.log("CHECKBOX CLICKEADO");

      //this.cargando = false;
    },
    // -----------------------------------------------------------------------------
    AgregarProducto(producto){
      if (!this.articulosAgregados.includes(producto)) {
        this.articulosAgregados.push(producto);
        console.log(this.articulosAgregados);
        console.log(JSON.stringify(this.articulosAgregados));
      }
    },
    // -----------------------------------------------------------------------------
    AgregarArticulo(articulo) {
      if (!this.articulosAgregados.includes(articulo)) {
        this.articulosAgregados.push(articulo);
        console.log(this.articulosAgregados);
      }
    },
    // -----------------------------------------------------------------------------
    QuitarProducto(producto) {
      const index = this.articulosAgregados.indexOf(producto);
      if (index > -1) {
        this.prodcutosAgregados.splice(index, 1);
      }
      console.log(this.articulosAgregados);
    },
    // -----------------------------------------------------------------------------
    async getArticulosProyecto() {
      //this.cargando = true;
      this.articulos = [];

      this.articulos = ( await axios.get(`${this.getURLAPI}/Pedidos/ArticulosPedido`)).data;
      this.articulos.forEach((articulo) => {
        articulo.CANTIDAD = 1;
      });

      //this.cargando = false;
    },
    // -----------------------------------------------------------------------------
    salir() {
      let close = confirm("¿Seguro que quieres salir de la pagina?");
      if (close) {
        this.$router.push("/requisicion");
      }
    },
    // -----------------------------------------------------------------------------
    crearPedido(){

      //console.log("CREAR PEDIDO CLICK");
      //console.log("ID SELECTED"+this.proyID);
      //console.log("BODEGA:"+this.almacenSeleccionado["ALMACEN_ID"]);.

      let datosForm = new FormData();

      if( this.descripcion !== '' && this.articulosAgregados.length > 0 && this.proyID !== 0 && (this.almacenSeleccionado != null || this.almacenSeleccionado != ""))
      {
        console.log("ENTRÉ AL IF");
        datosForm.append("PROYECTO_ID",     this.proyID);
        datosForm.append("DESCRIPCION",     this.descripcion);
        //datosForm.append("USUARIO_CREADOR", this.getUsuario);
        datosForm.append("ALMACEN_ID",      this.almacenSeleccionado["ALMACEN_ID"]);
        datosForm.append("ARTICULOS",       JSON.stringify(this.articulosAgregados));


  
        axios.post(`${this.getURLAPI}/Pedidos/insertarPedido`,datosForm)
        .then( ({data}) => {
          console.log("THEN DATA");
          this.$root.vtoast.show(
            { message: data.MSG, color: data.STATUS ? 'success darken-2':'red darken-2', 
              timer:10000, icon: data.STATUS ? 'mdi-check':'mdi-alert-circle-outline' } 
          )

          this.$router.push("/pedidos");
        } )
        .catch( ()=> {
          this.$root.vtoast.show(
            { message: 'Ocurrio un problema en el servidor', color:'red darken-2', 
              timer:10000, icon:'mdi-alert-circle-outline' } )
        })
      }    //datosForm.append("FECHA",           this.fechaSeleccionada);      
      else{
        this.$root.vtoast.show(
          {message: 'Verifica los campos.', color:'black darken-2', timer:10000, icon:'mdi-alert-circle-outline'}
        )
      }
    },
    // ---------------------------------------------------------------------------
    // LOG(){
    //   console.log(this.fechaSeleccionada);
    // },
  },

// -----------------------------------------------------------------------------
  created() {
    document.title = "Crear Pedido | Bombas y Suministros del Norte";
    this.minFecha = this.getFechaActual.split(" ");
    //this.getArticulos();
    console.log(this.minFecha);
    this.GetProyectos();
    this.getAlmacenes();
  },
};
</script>

<style>
.allB {
  border-style: solid;
  border-color: rgba(128, 128, 128, 0.349);
  border-width: 1px 1px 1px 1px;
}
</style>
